export const CATEGORY_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Categoría guardada exitosamente.",
  DISABLE_SUCCESS: "Categoría deshabilitada exitosamente.",
  ENABLE_SUCCESS: "Categoría habilitada exitosamente.",
};

export const CATEGORY_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar la categoría. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar la categoría. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar la categoría. Por favor, inténtalo de nuevo.",
};
